export default __webpack_public_path__ + "static/media/save.f54ba727.svg";